// extracted by mini-css-extract-plugin
module.exports = {"Container":"HeaderMiddle_Container__7m6rV","Input":"HeaderMiddle_Input__UGnAk","RightBlock":"HeaderMiddle_RightBlock__rQ8_V"};